<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h11"><span class="th10">Dedication</span></h1>
<p class="p4">J. and A. opened their home to me and shared their in-depth knowledge of local history. Without them, this story wouldn’t have half the depth it does. We spent hours poring over copies of the original cadastral maps and choosing just the right blocks of land for David and Bernard; then we drove over the creek and had a look at it. The land exists, still owned by the family of the first selectors. Needless to say, David and Bernard weren’t really there.</p>
<p class="p5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?7602f9ca